import styled from "styled-components";
import {
  FiCheckCircle,
  FiFileText,
  FiCreditCard,
  FiSearch,
  FiFilter,
  FiDownload,
  FiVideo,
  FiMessage,
} from "react-icons/fi";
import { CiCalendar } from "react-icons/ci";

// Styled Components
const Container = styled.div`
  padding: 20px;
  max-width: 80%;
  margin: 0 auto;
  margin-top: 90px;
  font-weight: 400;
  background-color: #fff;
  font-family: Montserrat;
`;

const Header = styled.div`
  margin-bottom: 20px;
  h1 {
    font-size: 24px;
    font-weight: 400;
    color: #333;
    margin-bottom: 4px;
  }
  p {
    color: #666;
    font-size: 14px;
  }
`;

const SummaryCards = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

const SummaryCard = styled.div`
  background: #fff;
  border-radius: 14px;
  padding: 25px;
  flex: 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.color || "#f0f0f0"};
  color: white;
`;

const TotalSpent = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dcfce7;
  color: #00a63e;
`;

const TotalTransactions = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dbeafe;
  color: #155dfc;
`;

const PaidThisMonth = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3e8ff;
  color: #9c27b0;
`;

const SummaryText = styled.div`
  h3 {
    font-size: 14px;
    color: #666;
    margin: 0;
    font-weight: 400;
  }
  p {
    font-size: 18px;
    font-weight: 400;
    margin: 5px 0 0;
  }
`;

const SearchBar = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  padding: 25px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;

  box-sizing: border-box;
  border: 1px solid rgba(229, 231, 235, 1);
  border-radius: 14px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1);
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border 0.3s;

  box-sizing: border-box;
  border: 1px solid rgba(209, 213, 220, 1);
  border-radius: 10px;

  &:focus {
    border-color: #666;
  }
`;

const SearchButton = styled.button`
  background: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #000;
  box-sizing: border-box;
  border: 1px solid rgba(209, 213, 220, 1);
  border-radius: 10px;
  font-size: 14px;

  &:hover {
    background: #e0e0e0;
  }
`;

const TransactionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const TransactionItem = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 15px;
`;

const Avatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-weight: 400;
  font-size: 18px;
`;

const Details = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Name = styled.p`
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
  color: #333;
`;

const Type = styled.p`
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const TypeTag = styled.span`
  background: ${(props) => props.color || "#e0e0e0"};
  color: ${(props) => props.textColor || "#333"};
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 5px;
`;

const DateId = styled.p`
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const Amount = styled.p`
  font-size: 1rem;
  font-weight: 400;
  color: #333;
  min-width: 80px;
  text-align: right;
`;

const Status = styled.span`
  background: #dcfce7;
  color: #00a63e;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 10px;
`;

// Sample Data
const transactions = [
  {
    id: 1,
    name: "Dr. Sarah Johnson",
    category: "Video Call",
    duration: "45 mins",
    date: "Jan 15, 2024",
    transactionId: "ID: TXN123456789",
    amount: 1200,
    status: "Completed",
  },
  {
    id: 2,
    name: "Dr. Michael Chen",
    category: "Chat Session",
    duration: "30 mins",
    date: "Jan 12, 2024",
    transactionId: "ID: TXN123456788",
    amount: 500,
    status: "Completed",
  },
  {
    id: 3,
    name: "Dr. Emily Rodriguez",
    category: "Video Call",
    duration: "40 mins",
    date: "Jan 10, 2024",
    transactionId: "ID: TXN123456787",
    amount: 800,
    status: "Completed",
  },
  {
    id: 4,
    name: "Dr. James Wilson",
    category: "Video Call",
    duration: "Cancelled",
    date: "Jan 8, 2024",
    transactionId: "ID: TXN123456786",
    amount: 1200,
    status: "Completed",
  },
  {
    id: 5,
    name: "Dr. Lisa Anderson",
    category: "Chat Session",
    duration: "30 mins",
    date: "Jan 5, 2024",
    transactionId: "ID: TXN123456785",
    amount: 500,
    status: "Completed",
  },
  {
    id: 6,
    name: "Dr. David Kumar",
    category: "Video Call",
    duration: "45 mins",
    date: "Jan 3, 2024",
    transactionId: "ID: TXN123456784",
    amount: 1200,
    status: "Completed",
  },
];

const totalSpent = 4200;
const totalTransactions = 6;
const thisMonth = 2500;

function PaymentHistory() {
  return (
    <Container>
      <Header>
        <h1>Payment History</h1>
        <p>View all your transaction history</p>
      </Header>

      <SummaryCards>
        <SummaryCard>
          <TotalSpent color="#4CAF50">
            <FiCheckCircle size={20} />
          </TotalSpent>
          <SummaryText>
            <h3>Total Spent</h3>
            <p>₹{totalSpent}</p>
          </SummaryText>
        </SummaryCard>
        <SummaryCard>
          <TotalTransactions color="#2196F3">
            <FiFileText size={20} />
          </TotalTransactions>
          <SummaryText>
            <h3>Total Transactions</h3>
            <p>{totalTransactions}</p>
          </SummaryText>
        </SummaryCard>
        <SummaryCard>
          <PaidThisMonth color="#9C27B0">
            <FiCreditCard size={20} />
          </PaidThisMonth>
          <SummaryText>
            <h3>This Month</h3>
            <p>₹{thisMonth}</p>
          </SummaryText>
        </SummaryCard>
      </SummaryCards>

      <SearchBar>
        <SearchInput
          type="text"
          placeholder="Search by expert name or transaction ID..."
        />
        <SearchButton>
          <FiFilter size={16} />
          Filter
        </SearchButton>
        <SearchButton>
          <FiDownload size={16} />
          Export
        </SearchButton>
      </SearchBar>

      <TransactionList>
        {transactions.map((transaction) => (
          <TransactionItem key={transaction.id}>
            <Avatar>{transaction.name.split(" ")[0][0]}</Avatar>
            <Details>
              <Name>{transaction.name}</Name>
              <Type>
                {/* <TypeTag
                  color={
                    transaction.category === "Video Call"
                      ? "#E1BEE7"
                      : "#F5F5F5"
                  }
                  textColor={
                    transaction.category === "Video Call"
                      ? "#4A148C"
                      : "#616161"
                  }
                >
                  {transaction.category}
                </TypeTag> */}
                <span> {transaction.category}</span>
                <span>- {transaction.duration}</span>
              </Type>
              <DateId>
                <CiCalendar size={16} color="#6A7282" />
                <span>{transaction.date}</span>
                <span>{transaction.transactionId}</span>
              </DateId>
            </Details>
            <Amount>₹{transaction.amount}</Amount>
            <Status>
              <FiCheckCircle size={20} color="#00A63E" />
              {transaction.status}
            </Status>
          </TransactionItem>
        ))}
      </TransactionList>
    </Container>
  );
}

export default PaymentHistory;
